// Carries the page a seller asked for across the Auth0 round trip in `appState`, because Auth0 validates the
// `redirect_uri` path against the tenant's Allowed Callback URLs and the MCP flow requires no tenant change.
// Only single-leading-slash paths are restorable, so `//evil.com` or `https://evil.com` never leave the app.

/** Shape of the `appState` this app sends through `loginWithRedirect`. */
export interface LoginAppState {
  readonly returnTo?: string
}

const isRestorablePath = (value: string): boolean => value.startsWith('/') && !value.startsWith('//')

export const hasAuthCallbackParams = (search: string): boolean => {
  const params = new URLSearchParams(search)
  return params.has('state') && (params.has('code') || params.has('error'))
}

/** The destination to record before sending the seller to Auth0; none for `/`, the default landing route. */
export const loginReturnTo = (pathname: string, search: string): string | undefined => {
  if (pathname === '/' || pathname === '') return undefined
  return `${pathname}${search}`
}

/** Where to navigate after the callback, which lands on `/` plus the original query, or `undefined` when the
 * browser is already there. */
export const restoreTarget = (
  appState: LoginAppState | undefined,
  currentPathAndSearch: string
): string | undefined => {
  const returnTo = appState?.returnTo
  if (!returnTo || !isRestorablePath(returnTo)) return undefined
  return returnTo === currentPathAndSearch ? undefined : returnTo
}
